// extracted by mini-css-extract-plugin
export var cardHeader = "_u1-0";
export var reorderHandle = "_u1-3";
export var titleArea = "_u1-1";
export var titleAreaWithHandle = "_u1-2";